import { Dictionary, mapKeys } from 'lodash'

type Error = {
  name: string
  input?: string
  error?: string
}

const EXCLUDE_FIELDS = [
  'password',
  'confirmPassword',
  'ssn',
  'confirmSsn',
  'licenseNumber',
  'birthday',
]

/**
 * Takes the error output thrown by the Form component
 * and formats it to a dictionary of type Error or a JSON
 * formatted string
 * @param errorOutput error output thrown by Form
 * @param formFields the fields prop from the Form component
 * @param returnJson if true, return JSON formatted string
 * @returns Dictionary of Errors
 */
export const formatErrorKeys = (
  errorOutput: Error[],
  formFields: object,
  returnJson = false
): Dictionary<Error> | string => {
  const keys = mapKeys(errorOutput, value => value.name)
  for (const field in formFields) {
    if (keys.hasOwnProperty(field) && !EXCLUDE_FIELDS.includes(field)) {
      keys[field].input = formFields[field].value
    }
  }

  if (returnJson) {
    return JSON.stringify(keys)
  }

  return keys
}
/**
 * Pass into a wrapper for onKeyDown to navigate input boxes
 * via enter key
 */

export const enterKeyFormNextFocus = e => {
  if (e.keyCode === 13 && e.target.nodeName === 'INPUT') {
    const form = e.target.form
    const index = Array.prototype.indexOf.call(form, e.target)
    if (
      form.elements[index].type === 'password' ||
      form.elements[index + 1].type === 'checkbox'
    ) {
      form.elements[index + 2].focus()
    } else {
      form.elements[index + 1].focus()
    }
  }
}
